import { makeAutoObservable } from "mobx"
import { safeJSONParse } from "../utils/safeJSONParse";

export default class ProductStore {
    constructor() {
       /* this._reload = 1

        // NewCategories
        this._categories = JSON.parse(window.localStorage.getItem('categories')) || []

        // Каталог
        this._products = JSON.parse(window.localStorage.getItem('products')) || []
        this._folders = JSON.parse(window.localStorage.getItem('folders')) || []
        this._selectedFolder = JSON.parse(window.localStorage.getItem('selectedFolder')) || { id: '2' }
        this._pagination = JSON.parse(window.localStorage.getItem('pagination')) || { pageNumber: 1, pageCount: 1 }

        // Поиск
        this._search = JSON.parse(window.localStorage.getItem('search')) || ""

        // Фильтры
        this._filters = JSON.parse(window.localStorage.getItem('filters')) || []/*[
            { id: 1, name: 'Цена', type: 'input', from: 0, to: 999999 },
            { id: 2, name: 'Бренд', type: 'select', value: 'Не важно', options: [] },
            { id: 3, name: 'Инвертор', type: 'select', value: 'Не важно', options: ['Не важно', 'Да', 'Нет'] },
            { id: 4, name: 'Площадь помещения', type: 'input', from: 0, to: 999 },
            { id: 5, name: 'Хладагент', type: 'select', value: 'Не важно', options: ['Не важно'] },
            { id: 6, name: 'Модельный ряд', type: 'select', value: 'Не важно', options: ['Не важно'] },
            { id: 7, name: 'Цвет', type: 'select', value: 'Не важно', options: ['Не важно'] },
        ]*//*
        this._brands = JSON.parse(window.localStorage.getItem('brands')) || []
        this._model = JSON.parse(window.localStorage.getItem('model')) || []
        this._invertor = JSON.parse(window.localStorage.getItem('invertor')) || []
        this._hladagent = JSON.parse(window.localStorage.getItem('hladagent')) || []
        this._color = JSON.parse(window.localStorage.getItem('color')) || []
        this._minSquere = JSON.parse(window.localStorage.getItem('minSquere')) || 0
        this._maxSquere = JSON.parse(window.localStorage.getItem('maxSquere')) || 999
        this._minPrice = JSON.parse(window.localStorage.getItem('minPrice')) || 0
        this._maxPrice = JSON.parse(window.localStorage.getItem('maxPrice')) || 999999

        // Корзина
        this._basketProducts = JSON.parse(window.localStorage.getItem('basketProducts')) || []
        //this._basketSum = JSON.parse(window.localStorage.getItem('basketSum')) || 0

        // тест фильтров 
        this.selectedFilters = { };
      makeAutoObservable(this)
    }*/

      this._reload = 1;

        // Категории и папки
        this._categories = safeJSONParse('categories', []);
        this._folders = safeJSONParse('folders', []);
        this._selectedFolder = safeJSONParse('selectedFolder', { id: '2' });

        // Каталог
        this._products = safeJSONParse('products', []);
        this._pagination = safeJSONParse('pagination', { page: 0, pageCount: 1, pageSize: 20 });

        // Поиск
        this._search = safeJSONParse('search', "");

        // Фильтры
        this._filters = safeJSONParse('filters', []);
        this._brands = safeJSONParse('brands', []);
        this._model = safeJSONParse('model', []);
        this._invertor = safeJSONParse('invertor', []);
        this._hladagent = safeJSONParse('hladagent', []);
        this._color = safeJSONParse('color', []);
        this._minSquere = safeJSONParse('minSquere', 0);
        this._maxSquere = safeJSONParse('maxSquere', 999);
        this._minPrice = safeJSONParse('minPrice', 0);
        this._maxPrice = safeJSONParse('maxPrice', 999999);

        // Корзина
        this._basketProducts = safeJSONParse('basketProducts', []);

        // Выбранные фильтры (новые)
        this._selectedFilters = safeJSONParse('selectedFilters', {});
        this.isLoading = safeJSONParse('isLoading ', false)

        makeAutoObservable(this);
    }


    setSelectedFilters(selectedFilters) {
        this._selectedFilters = selectedFilters;
        localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
    }
    get selectedFilters() {
        return this._selectedFilters;
    }

    get requestBodyFilter() {
        if (!this._selectedFilters || typeof this._selectedFilters !== 'object') {
            return { parameters: [] };
        }
            const parameters = Object.entries(this._selectedFilters).map(([name, value]) => {
                const type = this._filters.find(f => f.name === name)?.type;
    
                if (!type) return null;
    
                if (type === 'SELECT' && Array.isArray(value) && value.length > 0) {
                    return {
                        name,
                        type,
                        arguments: value,
                    };
                }
    
                if ((type === 'PRICE' || type === 'RANGE') && value?.from !== undefined && value?.to !== undefined) {
                    return {
                        name,
                        type,
                        from: value.from,
                        to: value.to,
                    };
                }

                if (type === 'SALE') {
                    return {
                        name,
                        type,
                        arguments: Array.isArray(value) ? value : [String(value)],
                    };
                }
    
                return null;
            }).filter(Boolean);
        //    console.log("parameters",parameters)
            return { parameters };
    }
    

    setReload(reload) {
        this._reload = reload
    }
    get reload() {
        return this._reload
    }

    // NewCategories
    setCategories(categories) {
        this._categories = categories
        window.localStorage.setItem('categories', JSON.stringify(categories));
    }
    get categories() {
        return this._categories
    }

    // Каталог
    setProducts(products) {
        this._products = products
        localStorage.setItem('products', JSON.stringify(products));
    }
    get products() {
        return this._products
    }

    setFolders(folders) {
        this._folders = folders
        localStorage.setItem('folders', JSON.stringify(folders));
    }
    get folders() {
        return this._folders
    }

    setSelectedFolder(selectedFolder) {
        this._selectedFolder = selectedFolder
        localStorage.setItem('selectedFolder', JSON.stringify(selectedFolder));
    }
    get selectedFolder() {
        return this._selectedFolder
    }

    // Пагинация - общее
    setPagination(pagination) {
        this._pagination = pagination;
        localStorage.setItem('pagination', JSON.stringify(pagination));
    }
    get pagination() {
        return this._pagination;
    }
    
    // Текущая страница
    setPage(page) {
        this._pagination.page = page;
        localStorage.setItem('pagination', JSON.stringify(this._pagination));
    }
    get page() {
        return this._pagination.page;
    }
    
    // Кол-во страниц
    setPageCount(pageCount) {
        this._pagination.pageCount = pageCount;
        localStorage.setItem('pagination', JSON.stringify(this._pagination));
    }
    get pageCount() {
        return this._pagination.pageCount;
    }
    setLoading(bool) {
      this.isLoading = bool;
    }
    
    // Размер страницы
    setPageSize(pageSize) {
        this._pagination.pageSize = pageSize;
        localStorage.setItem('pagination', JSON.stringify(this._pagination));
    }
    get pageSize() {
        return this._pagination.pageSize;
    }

    // Поиск
    setSearch(search) {
        this._search = search
        localStorage.setItem('search', JSON.stringify(search));
    }
    get search() {
        return this._search
    }

    // Фильтры
    setFilters(filters) {
        this._filters = filters
        localStorage.setItem('filters', JSON.stringify(filters));
    }
    
    get filters() {
        return this._filters
    }

    setBrands(brands) {
        this._brands = brands
        localStorage.setItem('brands', JSON.stringify(brands));
    }
    get brands() {
        return this._brands
    }

    setModel(model) {
        this._model = model
        localStorage.setItem('model', JSON.stringify(model));
    }
    get model() {
        return this._model
    }

    setInvertor(invertor) {
        this._invertor = invertor
        localStorage.setItem('invertor', JSON.stringify(invertor));
    }
    get invertor() {
        return this._invertor
    }

    setHladagent(hladagent) {
        this._hladagent = hladagent
        localStorage.setItem('hladagent', JSON.stringify(hladagent));
    }
    get hladagent() {
        return this._hladagent
    }

    setColor(color) {
        this._color = color
        localStorage.setItem('color', JSON.stringify(color));
    }
    get color() {
        return this._color
    }

    setMinSquere(minSquere) {
        this._minSquere = minSquere
        localStorage.setItem('minSquere', JSON.stringify(minSquere));
    }
    get minSquere() {
        return this._minSquere
    }
    setMaxSquere(maxSquere) {
        this._maxSquere = maxSquere
        localStorage.setItem('maxSquere', JSON.stringify(maxSquere));
    }
    get maxSquere() {
        return this._maxSquere
    }

    setMinPrice(minPrice) {
        this._minPrice = minPrice
        localStorage.setItem('minPrice', JSON.stringify(minPrice));
    }
    get minPrice() {
        return this._minPrice
    }
    setMaxPrice(maxPrice) {
        this._maxPrice = maxPrice
        localStorage.setItem('maxPrice', JSON.stringify(maxPrice));
    }
    get maxPrice() {
        return this._maxPrice
    }

    /*resetFilters() {
        this.setBrands([])
        this.setHladagent([])
        this.setModel([])
        this.setInvertor([])
        this.setColor([])
        this.setMinSquere(0)
        this.setMaxSquere(999)
        this.setMinPrice(0)
        this.setMaxPrice(999999)
    }*/

    // Корзина
    setBasketProducts(basketProducts) {
        this._basketProducts = basketProducts
        localStorage.setItem('basketProducts', JSON.stringify(basketProducts));
    }
    get basketProducts() {
        return this._basketProducts
    }
    addBasketProduct(product) {
        product.count = 1
        this._basketProducts.push(product)
        localStorage.setItem('basketProducts', JSON.stringify(this._basketProducts));
    }
    getBasketCount(product) {
        var result = this._basketProducts.filter((bp) => (
            bp.id === product.id
        ))
        return result.length > 0 ? result[0].count : 0
    }
    changeCountBasketProduct(product, count) {
        if (count === 0) {
          this._basketProducts = this._basketProducts.filter((bp) => bp.id !== product.id);
        } else {
          this._basketProducts = this._basketProducts.map((bp) =>
            bp.id === product.id ? { ...bp, count } : bp
          );
        }
      
        localStorage.setItem('basketProducts', JSON.stringify(this._basketProducts));
      }

    // setBasketSum(basketSum) {
    //     this._basketSum = basketSum
    //     localStorage.setItem('basketSum', JSON.stringify(basketSum));
    // }
    get basketSum() {
        var  sum = 0;
        this._basketProducts?.forEach((bp) => (
            sum += (bp.isSale ? bp.salePrice : bp.price) * bp.count
        ))
        return sum
    }
}